"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentSchema = void 0;
exports.PaymentSchema = {
  type: 'object',
  required: ['form_id', 'email_campaign_id', 'thank_you_page_id'],
  additionalProperties: false,
  properties: {
    form_id: {
      type: ['string', 'null']
    },
    page_ids: {
      type: 'array',
      items: {
        type: 'string'
      }
    },
    email_campaign_id: {
      type: ['string', 'null']
    },
    thank_you_page_id: {
      type: ['string', 'null']
    },
    failed_page_id: {
      type: ['string', 'null']
    },
    cancellation_workflow_id: {
      type: ['string', 'null']
    },
    decline_workflow_id: {
      type: ['string', 'null']
    },
    order_in_progress_stage_name: {
      type: 'string'
    },
    order_completed_stage_name: {
      type: 'string'
    },
    next_workflow_ids: {
      type: 'object',
      properties: {
        next_workflow: {
          type: ['string', 'null']
        }
      }
    }
  }
};
